import React from 'react';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Domingo a la noche buscando ejercicios para la clase del lunes que nunca quedaban bien', 'Clases improvisadas porque no tenías estructura, ni progresión, ni guion claro', 'Alumnos que abandonaban a los 2 meses porque no veían resultados reales', 'Evaluaciones inventadas en el momento porque no tenías criterios definidos', 'Horas perdidas preparando material que nunca se recuperan'];
  return <section className="py-6 md:py-8 px-4 bg-brand-dark" data-id="element-115">
      <div className="max-w-2xl mx-auto" data-id="element-116">
        <h2 className="text-base md:text-xl font-black text-center mb-4 text-white leading-tight" data-id="element-117">
          Si sos profesor o entrenador de vóley, esto te va a sonar familiar:
        </h2>

        <div className="bg-brand-card border-l-4 border-red-500 p-4 rounded-r-lg mb-4" data-id="element-118">
          <div className="space-y-2.5" data-id="element-119">
            {points.map((point, index) => <div key={index} className="flex items-start" data-id="element-120">
                <XCircle className="w-4 h-4 text-red-500 mr-2 shrink-0 mt-0.5" data-id="element-121" />
                <p className="text-xs md:text-sm text-gray-300 font-medium leading-relaxed" data-id="element-122">
                  {point}
                </p>
              </div>)}
          </div>
        </div>

        <div className="text-center space-y-2" data-id="element-123">
          <h3 className="text-sm md:text-lg font-black text-brand-accent neon-glow leading-tight" data-id="element-124">
            ¿Cuántos fines de semana más vas a perder haciendo lo mismo?
          </h3>
          <p className="text-[10px] md:text-xs text-gray-400 font-medium leading-relaxed" data-id="element-125">
            Da igual si enseñás en Buenos Aires, en Ciudad de México, en Bogotá,
            en Santiago, en Lima o en cualquier ciudad de Latinoamérica. El
            problema es exactamente el mismo.{' '}
            <span className="text-white font-bold" data-id="element-126">Y la solución también.</span>
          </p>
        </div>
      </div>
    </section>;
}